import {
    ROUTINE_RISKFREE_WORKFLOW_PATH,
    ROUTINE_LIQUIDEZ_WORKFLOW_PATH,
    ROUTINE_SPREAD_RELATIVO_WORKFLOW_PATH,
    ROUTINE_PRECOS_PROCESSADOS_WORKFLOW_PATH,
    ROUTINE_VOLATILIDADE_WORKFLOW_PATH,
    ROUTINE_CLIENTE_PRECOS_LOG_WORKFLOW_PATH,
    ROUTINE_CURVAS_WORKFLOW_PATH,
    ROUTINE_CURVAS_V2_WORKFLOW,
    ROUTINE_PRECOS_EVENTOS_FINANCEIROS_WORKFLOW_PATH,
    ROUTINE_PRECOS_EVENTOS_LISTA_WORKFLOW_PATH,
    ROUTINE_PRECOS_LISTA_CETIPS_WORKFLOW_PATH,
    ROUTINE_PRECOS_TUNEL_WORKFLOW_PATH,
    ROUTINE_PRECOS_VALIDACAO_WORKFLOW_PATH,
    ROUTINE_SPREADS_BRUTOS_TRATADOS_WORKFLOW_PATH,
    ROUTINE_SPREADSEMISSAO_WORKFLOW_PATH,
    ROUTINE_SPREADS_NEGOCIADOS_WORKFLOW_PATH,
    ROUTINE_SPREADS_NEGOCIADOS_CONSOLIDADOS_WORKFLOW_PATH,
    ROUTINE_PRECOS_ANDADOS_WORKFLOW_PATH,
    ROUTINE_B3_FUNDOS_NET_V2_WORKFLOW_PATH,
} from "src/utils/api-routes"

export const routineDataWorkflowList = [
    {value: "ClientePrecosLogWorkflow", description: "Cliente Precos Log Workflow"},
    {value: "CurvasWorkflow", description: "Curvas Workflow"},
    {value: "CurvasV2Workflow", description: "Curvas V2 Workflow"},
    {value: "LiquidezWorkflow", description: "Liquidez Workflow"},
    {value: "PrecosAndadosWorkflow", description: "Preços Andados Workflow"},
    {value: "PrecosEventosFinanceirosWorkflow", description: "Preços Eventos Financeiros Workflow"},
    {value: "PrecosEventosListaWorkflow", description: "Preços Eventos Lista Workflow"},
    {value: "PrecosListaCetipsWorkflow", description: "Preços Lista Cetips Workflow"},
    {value: "PrecosProcessadosWorkflow", description: "Preços Processados Workflow"},
    {value: "PrecosValidacaoWorkflow", description: "Preços Validação Workflow"},
    {value: "SpreadsBrutosTratadosWorkflow", description: "Spreads Brutos Tratados Workflow"},
    {value: "SpreadEmissaoWorkflow", description: "Spread Emissão Workflow"},
    {value: "SpreadNegociadoWorkflow", description: "Spread Negociado Workflow"},
    {value: "SpreadsNegociadosConsolidadosWorkflow", description: "Spreads Negociados Consolidados Workflow"},
    {value: "SpreadRelativoWorkflow", description: "Spread Relativo Workflow"},
    {value: "TratamentoRiskFree", description: "Tratamento Risk Free"},
    {value: "PrecosTunelWorkflow", description: "Túnel de Preços Workflow", disabled: false},
    {value: "VolatilidadeCurvasWorkflow", description: "Volatilidade de Curvas Workflow"},
    {value: "B3FundosNetV2Workflow", description: "B3 Fundos NET V2 Workflow"},
]

export const routineEndpointWorkflowList = [
    {value: "VolatilidadeCurvasWorkflow", endpoint: ROUTINE_VOLATILIDADE_WORKFLOW_PATH},
    {value: "Curvas", endpoint: ROUTINE_CURVAS_WORKFLOW_PATH},
    {value: "CurvasV2Workflow", endpoint: ROUTINE_CURVAS_V2_WORKFLOW},
    {value: "PrecosAndadosWorkflow", endpoint: ROUTINE_PRECOS_ANDADOS_WORKFLOW_PATH},
    {value: "SpreadsBrutosTratadosWorkflow", endpoint: ROUTINE_SPREADS_BRUTOS_TRATADOS_WORKFLOW_PATH},
    {value: "SpreadEmissaoWorkflow", endpoint: ROUTINE_SPREADSEMISSAO_WORKFLOW_PATH},
    {value: "SpreadNegociadoWorkflow", endpoint: ROUTINE_SPREADS_NEGOCIADOS_WORKFLOW_PATH},
    {value: "SpreadsNegociadosConsolidadosWorkflow", endpoint: ROUTINE_SPREADS_NEGOCIADOS_CONSOLIDADOS_WORKFLOW_PATH},
    {value: "TratamentoRiskFree", endpoint: ROUTINE_RISKFREE_WORKFLOW_PATH},
    {value: "ClientePrecosLogWorkflow", endpoint: ROUTINE_CLIENTE_PRECOS_LOG_WORKFLOW_PATH},
    {value: "LiquidezWorkflow", endpoint: ROUTINE_LIQUIDEZ_WORKFLOW_PATH},
    {value: "SpreadRelativoWorkflow", endpoint: ROUTINE_SPREAD_RELATIVO_WORKFLOW_PATH},
    {value: "PrecosProcessadosWorkflow", endpoint: ROUTINE_PRECOS_PROCESSADOS_WORKFLOW_PATH},
    {value: "PrecosEventosFinanceirosWorkflow", endpoint: ROUTINE_PRECOS_EVENTOS_FINANCEIROS_WORKFLOW_PATH},
    {value: "PrecosEventosListaWorkflow", endpoint: ROUTINE_PRECOS_EVENTOS_LISTA_WORKFLOW_PATH},
    {value: "PrecosListaCetipsWorkflow", endpoint: ROUTINE_PRECOS_LISTA_CETIPS_WORKFLOW_PATH},
    {value: "PrecosTunelWorkflow", endpoint: ROUTINE_PRECOS_TUNEL_WORKFLOW_PATH, disabled: true},
    {value: "PrecosValidacaoWorkflow", endpoint: ROUTINE_PRECOS_VALIDACAO_WORKFLOW_PATH},
    {value: "B3FundosNetV2Workflow", endpoint: ROUTINE_B3_FUNDOS_NET_V2_WORKFLOW_PATH},
]